// extracted by mini-css-extract-plugin
module.exports = {"item":"InvoiceItem_item__1l2-p","itemInfo":"InvoiceItem_itemInfo__1fL-h","itemLabel":"InvoiceItem_itemLabel__3_SdF"};